exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dmb-web__FHACard__table__13WWO {\n  margin-left: 9px;\n}\n\n.dmb-web__FHACard__table__13WWO img {\n  max-height: 100px;\n  max-width: 100px;\n  padding-top: 5px;\n}\n\n.dmb-web__FHACard__table__13WWO td {\n  padding: 0 5px;\n}\n", ""]);

// exports
exports.locals = {
	"table": "dmb-web__FHACard__table__13WWO"
};